import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { Modal } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useState, useEffect } from "react";

import style from "../../../../../../../Style.module.css";
import module_style from "../Style.module.css";

import api from "data/APIs";
import constants from "constants/constants";

import { logError } from "utils/error";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import { form_data, UPDATE_NAME_TEXTS } from "../../sidebar.constant";
import {
  EXLY_WEBPAGE_DETAILS__UPDATE_SKU_NAME,
  EXLY_WEBPAGE_DETAILS__REFETCH_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS,
} from "ui/pages/TemplatePreview/redux/actions";

const isSkuOrPlanOrListing = (type) =>
  type === form_data.sku ||
  type === form_data.plan ||
  type === form_data.listings;

const getInitialTitle = ({ type, data, selectedValue }) => {
  if (type === form_data.sku)
    return data.listings_data?.sku_map?.listings[selectedValue];
  if (type === form_data.plan) return data.plans_data.title;
  if (type === form_data.listings) return data.listings_data.title;
  return selectedValue.keyword;
};

const UpdateName = ({ showModal, type }) => {
  const dispatch = useDispatch();
  const { pushNotif } = useContext(WebpageCreationContext);

  const listingsOrKeywordsData = useSelector((state) =>
    isSkuOrPlanOrListing(type)
      ? state.webpage_detail.listings
      : state.webpage_detail.keywords
  );

  const selectedValue = useSelector((state) =>
    type === form_data.sku
      ? state.webpage_detail.selected_sku
      : state.webpage_detail.selected_keyword
  );

  const isUpdating = useSelector((state) => state.webpage_detail.updating);

  const [title, setTitle] = useState(
    getInitialTitle({ type, data: listingsOrKeywordsData, selectedValue })
  );

  useEffect(() => {
    if (!isUpdating) showModal(false);
  }, [isUpdating]);

  const refetchListings = () =>
    dispatch({ type: EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS });
  const refetchKeywords = () =>
    dispatch({ type: EXLY_WEBPAGE_DETAILS__REFETCH_KEYWORDS });

  const handleClose = () => showModal(false);

  const handleSkuSave = () => {
    dispatch({ type: EXLY_WEBPAGE_DETAILS__UPDATE_SKU_NAME, sku_name: title });
  };

  const { mutate: mutatePlanHeading } = useCustomMutation({
    url: api.update_plan_heading,
    onSuccess: (response) => {
      pushNotif(response.message);
      showModal(false);
      refetchListings();
    },
  });

  const { mutate: mutateListingHeading } = useCustomMutation({
    url: api.update_listing_heading,
    onSuccess: (response) => {
      pushNotif(response.message);
      showModal(false);
      refetchListings();
    },
  });

  const { mutate: mutateKeywordName } = useCustomMutation({
    url: api.update_keyword_name,
    onSuccess: (response) => {
      pushNotif(response.message);
      refetchListings();
      refetchKeywords();
    },
  });

  const handlePlanSave = () => {
    mutatePlanHeading({ plan_heading: title });
  };

  const handleListingSave = () => {
    mutateListingHeading({ listing_heading: title });
  };

  const handleKeywordSave = () => {
    const matchedKeywords = listingsOrKeywordsData.filter(
      (item) => item.uuid === selectedValue.uuid
    );
    if (checkIsArrayEmpty(matchedKeywords)) return;

    const matchedKeyword = matchedKeywords[0];
    mutateKeywordName({
      keyword_uuid: matchedKeyword.uuid,
      keyword_value: title,
    });
  };

  const handleSave = () => {
    try {
      if (type === form_data.sku) handleSkuSave();
      else if (type === form_data.plan) handlePlanSave();
      else if (type === form_data.listings) handleListingSave();
      else handleKeywordSave();

      showModal(false);
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/Modals/UpdateName.js",
        when: "handleSave in headings",
      });
      pushNotif(err?.body?.message || constants.error_message);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={true}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <div className={`alert_modal ${style.modal}`}>
        <input
          onChange={(e) => setTitle(e.target.value)}
          className={`w-100 ${module_style.text_input}`}
          type="text"
          value={title}
        />
        <div className="row no-gutters mt-3">
          <div onClick={handleSave} className={`${style.new_save_cta} mr-4`}>
            {isUpdating ? UPDATE_NAME_TEXTS.SAVING : UPDATE_NAME_TEXTS.SAVE}
          </div>
          <div onClick={handleClose} className={style.new_alt_cta}>
            {UPDATE_NAME_TEXTS.CANCEL}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateName;
